export default "__VITE_ASSET__ea88e704__"